<template>
  <v-card>
    <v-alert type="success" v-if="notification.type == 'success'">{{
      notification.message
    }}</v-alert>
    <v-alert type="error" v-if="notification.type == 'error'">{{
      notification.message
    }}</v-alert>
    <v-tabs v-model="tab" grow>
      <v-tab>Share an update</v-tab>
      <v-tab>Upload a photo/video</v-tab>
      <v-tab>Share an event</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-form ref="ref_form0">
          <v-textarea
            solo
            label="Write your thoughts..."
            rows="4"
            flat
            no-resize
            v-model="ref0.thought"
            :rules="[myrules.required]"
          ></v-textarea>
        </v-form>
      </v-tab-item>
      <v-tab-item>
        <v-form ref="ref_form1">
          <div class="pa-4">
            <v-file-input
              solo
              label="Share File/Photo"
              outlined
              dense
              flat
              no-resize
              v-model="ref1.media"
              :rules="[myrules.required]"
            ></v-file-input>
            <v-textarea
              solo
              placeholder="Description"
              outlined
              dense
              flat
              no-resize
              v-model="ref1.description"
              :rules="[myrules.required]"
            />
          </div>
        </v-form>
      </v-tab-item>
      <v-tab-item>
        <v-form ref="ref_form2">
          <div class="pa-4">
            <v-text-field
              solo
              flat
              dense
              outlined
              label="Title"
              v-model="ref2.title"
              :rules="[myrules.required]"
            />
            <v-textarea
              solo
              label="Description"
              rows="4"
              flat
              no-resize
              outlined
              v-model="ref2.description"
              :rules="[myrules.required]"
            ></v-textarea>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date"
                  label="Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  dense
                  outlined
                ></v-text-field>
              </template>
              <v-date-picker v-model="date" :min="moment(new Date()).format('YYYY-MM-DD')" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu = false">
                  Cancel
                </v-btn>
                <v-btn text color="primary" @click="$refs.menu.save(date)">
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
            <v-file-input
              solo
              flat
              dense
              outlined
              label="File"
              v-model="ref2.media"
            />
            <v-autocomplete
              deletable-chips
              multiple
              small-chips
              solo
              flat
              dense
              outlined
              label="Genre"
              :items="getGenre"
              v-model="ref2.genre"
              :rules="[myrules.arrayRequired]"
            ></v-autocomplete>
          </div>
        </v-form>
      </v-tab-item>
    </v-tabs-items>
    <div class="d-flex align-center px-3 pb-3">
      <!-- <small>
            <i class="fa fa-map-marker mr-2"></i>Add Location
          </small> -->
      <div class="ml-auto">
        <!-- <v-btn class="mr-2" small>Preview</v-btn> -->
        <v-btn small color="primary" :loading="loading" @click="lc_create_post"
          >Post Status</v-btn
        >
      </div>
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from  "moment";
export default {
  props: ["handleSubmit", "loading", "notification"],
  data() {
    return {
      tab: null,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      ref0: {
        thought: "",
      },
      ref1: {
        media: null,
        description: "",
      },
      ref2: {
        title: "",
        description: "",
        media: null,
        genre: [],
      },
    };
  },
  methods: {
    moment,
    async lc_create_post(e) {
      e.preventDefault();
      let validate = false;
      let user_id = this.authUser.id;
      let data = {};
      switch (parseInt(this.tab)) {
        case 0:
          validate = this.$refs.ref_form0.validate();
          if (validate) {
            data = { ...this.ref0, type: "thought", user_id };
          }
          break;
        case 1:
          validate = this.$refs.ref_form1.validate();
          if (validate) {
            data = { ...this.ref1, type: "media", user_id };
          }
          break;
        case 2:
          validate = this.$refs.ref_form2.validate();
          if (validate) {
            data = {
              ...this.ref2,
              event_date: this.date,
              type: "event",
              user_id,
            };
          }
          break;
      }
      if (validate) {
        await this.handleSubmit(data);
        if (this.$refs.ref_form0) this.$refs.ref_form0.reset();
        if (this.$refs.ref_form1) this.$refs.ref_form1.reset();
        if (this.$refs.ref_form2) this.$refs.ref_form2.reset();
      }
    },
  },
  computed: {
    ...mapGetters(["getGenre"]),
  },
};
</script>

<style>
</style>